import React from "react";
import { Box, Stack, Typography, Link } from "@mui/material";
import logoWhiteImage from "url:src/assets/images/logo-white.png";

export default function Footer() {
  const menuSections = [
    {
      title: "無料売却AI査定",
      items: [
        { label: "特徴", href: "/#features-section" },
        { label: "成約事例", href: "/#case-section" },
        { label: "売却の流れ", href: "/#sell-flow-section" },
        { label: "よくある質問", href: "/#faq-section" },
      ],
    },
    {
      title: "株式会社Propally",
      items: [
        { label: "会社概要", href: "https://propally.co.jp/#company", external: true },
        { label: "お問い合わせ", href: "mailto:info@propally.co.jp" },
        { label: "プライバシーポリシー", href: "https://propally.co.jp/privacypolicy.html", external: true },
      ],
    },
  ];

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "primary.dark",
        color: "white",
        padding: "60px 20px",
      }}
    >
      <Stack spacing={4}>
        <Box>
          <Box
            component="img"
            src={logoWhiteImage}
            alt="Propally"
            sx={{
              width: "160px",
            }}
          />
        </Box>

        {menuSections.map((section, sectionIndex) => (
          <Stack key={sectionIndex} spacing={2}>
            <Typography fontWeight="bold" letterSpacing="0.13em">
              {section.title}
            </Typography>
            <Stack spacing={1}>
              {section.items.map((item, itemIndex) => {
                // 外部リンク・mailtoはそのまま
                if (item.external || item.href.startsWith("mailto:")) {
                  return (
                    <Link
                      key={itemIndex}
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        color: "white",
                        letterSpacing: "0.13em",
                        fontSize: "14px",
                        "&:hover": { opacity: 0.8 },
                        textDecoration: "none",
                      }}
                    >
                      {item.label}
                    </Link>
                  );
                }
                // 内部ハッシュリンクの場合は、クエリを維持して遷移
                const isHashLink = item.href.startsWith("/#");
                const href = isHashLink ? `${location.pathname}${location.search}${item.href.substring(1)}` : item.href;

                return (
                  <Link
                    key={itemIndex}
                    href={href}
                    sx={{
                      color: "white",
                      letterSpacing: "0.13em",
                      fontSize: "14px",
                      "&:hover": { opacity: 0.8 },
                      textDecoration: "none",
                    }}
                  >
                    {item.label}
                  </Link>
                );
              })}
            </Stack>
          </Stack>
        ))}

        <Box
          sx={{
            height: "1px",
            backgroundColor: "white",
            margin: "32px 0",
          }}
        />

        <Stack spacing={1}>
          <Link
            href="https://storyset.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "white",
              textDecoration: "none",
              fontSize: "14px",
              "&:hover": {
                opacity: 0.8,
              },
            }}
          >
            Illustration by Storyset
          </Link>
          <Typography
            sx={{
              color: "white",
              fontSize: "14px",
              opacity: 0.8,
            }}
          >
            © 2025 Propalty All Rights Reserved.
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
}
